import { getSubscribeToken, publish as mercurePublish } from '@api/mercure/apiMercure';
import { Logger } from '@tools/logger/logger';

type OnMessage<T> = (data: T, rawEvent: MessageEvent<string>) => void;

export const useMercure = (topic: string) => {
  const { mercurePublicUrl } = window;

  const publish = async <T>(payload?: T): Promise<void> => {
    await mercurePublish(topic, payload);
  };

  const subscribe = async <T>(onMessage: OnMessage<T>): Promise<void> => {
    const token = await getSubscribeToken(topic);

    if (!token) {
      Logger.error('Unable to get subscription token');
      return;
    }

    const url = new URL(mercurePublicUrl);
    url.searchParams.append('topic', topic);
    url.searchParams.append('authorization', token);

    const eventSource = new EventSource(url);

    eventSource.onerror = (e) => Logger.error('SSE error', e);
    eventSource.onmessage = (event: MessageEvent<string>) => {
      const data = JSON.parse(event.data) as T;
      onMessage(data, event);
    };
  };

  return {
    publish,
    subscribe,
  };
};
